import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateSpeaker, getSpeakerById } from "api/speaker.api";
import SpeakerForm from "components/speaker/SpeakerForm";
import Toast from "components/Toast";
export default function EditSpeaker() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    fetchSpeaker();
  }, []);

  const fetchSpeaker = async () => {
    try {
      const res = await getSpeakerById(id);
      setInitialData(res.data?.data || res.data);
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (fd) => {
    try {
      await updateSpeaker(id, fd);
      setToast({
        open: true,
        title: "Success",
        message: "Speaker updated successfully",
        type: "success",
      });
      // navigate("/admin/speakers");
    } catch (err) {
      console.error(err);
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
           navigate("/admin/speakers");
        }}
      />
      <SpeakerForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onBack={() => navigate("/admin/speakers")}
        alert={alert}
        setAlert={setAlert}
      />
    </>
  );
}